module.exports = __webpack_public_path__ + "static/media/v2-10.f1247237.webp";